// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u2Cl","col":"styles_col__ioL6m"};